import {
  AccountType,
  AccountTypeDetails,
  AccountTypeFeePeriod,
  AccountTypeStatus,
} from '@/types/api/account';

export const BASE_ACCOUNT_TYPES: AccountTypeDetails[] = [
  {
    id: '1',
    name: 'Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '10',
    classCode: 100,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '2',
    name: 'Coming Soon',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 101,
    description: 'Coming Soon',
    highlight: 'Coming Soon',
    detail: 'Coming Soon',
  },
  {
    id: '3',
    name: 'Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 102,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '4',
    name: '4 Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 103,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '5',
    name: '5 Savings',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 104,
    description: 'Savings',
    highlight: 'Savings',
    detail: 'Savings',
  },
];

export const SELECTED_ACCOUNT_TYPES: AccountTypeDetails[] = [
  {
    classCode: 203,
    description: 'e-Free account',
    detail:
      '<p><b>Bank FREE, easy and convenient.</b><br><br>If you prefer using RepublicOnline, RepublicMobile EC App or our ATMs rather then visiting our branches, then E-Free is the account for you!<br><br><b>Product information</b><ul><li>No Monthly Fee.</li><li>3 free monthly debits in-branch. If you exceed this limit you will have to pay a monthly fee of XCD15.00</li></ul><b>Features and Benefits</b><ul><li>Monthly e-statements at end of month.</li></ul><b>Rates and Fees</b><ul><li>No Monthly Fee</li><li>3 free monthly debits in-branch. If you exceed this limit you will have to pay a monthly fee of XCD15.00</li></ul></p>',
    fee: '0.00',
    feeCurrency: 'XCD',
    feePeriod: AccountTypeFeePeriod.Monthly,
    highlight:
      '<ul><li>No engagement</li><li>Free debit card</li><li>XCD currency</li></ul>',
    id: 'fa87c444-7bf2-4603-9bfa-ed02c7402531',
    isEligible: true,
    name: 'e-Free account',
    reachedMaxAccountsPerType: false,
    status: AccountTypeStatus.Active,
    type: AccountType.Checking,
  },
  {
    classCode: 202,
    conditionalNote:
      '/No Monthly Fee!<br>once a Minimum Balance of XCD 100.00 is maintained',
    description: 'Savings Plus account',
    detail:
      '<p>The Savings Plus account is specifically designed for the serious saver who can maintain a monthly balance in excess of XCD100.00.<br><br><b>Product information</b><ul><li>Interest of 2.00% P.A. (Per Annum)</li><li>Minimum opening balance of XCD100.00</li></ul><b>Features and Benefits</b><ul><li>Unlimited deposits and transfers at Republic Bank ATMs</li><li>Unlimited access to Republic<i>Online</i> and Republic<i>Mobile</i> EC App</li><li>Interest calculated on the minimum monthly balance and paid monthly</li><li>Quarterly e-statements available via Republic<i>Online</i> or Republic<i>Mobile</i> EC app</li></ul><b>Rates and Fees</b><ul><li>2 free withdrawals per quarter. XCD5.00 per withdrawal after</li><li>No monthly fee if you maintain the minimum required balance.</li></ul></p>',
    fee: '0.00',
    feeCurrency: 'XCD',
    feePeriod: AccountTypeFeePeriod.Conditional,
    highlight:
      '<ul><li>2.00% P.A. interest</li><li>Unlimited ATM deposits</li><li>Quarterly e-statements</li></ul>',
    id: '722264ca-89f2-43c7-be6e-e86d239b5bde',
    isEligible: true,
    name: 'Savings Plus account',
    reachedMaxAccountsPerType: false,
    status: AccountTypeStatus.Active,
    type: AccountType.Savings,
  },
];

export const ALL_ACCOUNT_TYPES: AccountTypeDetails[] = [
  {
    id: '1',
    name: '1 - Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '10',
    classCode: 100,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '2',
    name: '2 - Coming Soon',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 100,
    description: 'Coming Soon',
    highlight: 'Coming Soon',
    detail: 'Coming Soon',
  },
  {
    id: '3',
    name: '3 - Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 100,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '4',
    name: '4 - Personal Chequing Account',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 100,
    description: 'Personal Chequing Account',
    highlight: 'Personal Chequing Account',
    detail: 'Personal Chequing Account',
  },
  {
    id: '5',
    name: '5 - Savings',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    feeCurrency: 'USD',
    fee: '5',
    classCode: 100,
    description: 'Savings',
    highlight: 'Savings',
    detail: 'Savings',
  },
  // 20 more generated account types
  {
    id: '6',
    name: '6 - Basic Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'GBP',
    fee: '0',
    classCode: 100,
    description: 'No-fee basic savings account',
    highlight: 'No monthly fee',
    detail: 'Ideal for everyday saving with zero monthly fee.',
  },
  {
    id: '7',
    name: '7 - Premium Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '15',
    classCode: 200,
    description: 'Premium chequing with perks',
    highlight: 'Priority support & overdraft',
    detail: 'Includes premium support and overdraft protection.',
  },
  {
    id: '8',
    name: '8 - Student Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'CAD',
    fee: '0',
    classCode: 100,
    description: 'Savings for students',
    highlight: 'No fees for students',
    detail: 'Designed for students with no monthly maintenance fees.',
  },
  {
    id: '9',
    name: '9 - Business Chequing Basic',
    type: 'BUS',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '20',
    classCode: 300,
    description: 'Basic business chequing',
    highlight: 'Low transaction fees',
    detail: 'For small businesses with moderate transaction volume.',
  },
  {
    id: '10',
    name: '10 - Business Savings',
    type: 'BUS',
    status: AccountTypeStatus.ComingSoon,
    classCode: 300,
    description: 'Savings for businesses',
    highlight: 'Earn interest on reserves',
    detail: 'Coming soon: optimized for business cash reserves.',
  },
  {
    id: '11',
    name: '11 - High Yield Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '0',
    classCode: 200,
    description: 'Higher interest rate savings',
    highlight: 'Better interest rate',
    detail: 'Earn higher interest with balance-tier benefits.',
  },
  {
    id: '12',
    name: '12 - Joint Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '8',
    classCode: 100,
    description: 'Joint account for two or more owners',
    highlight: 'Shared access',
    detail: 'Allows multiple account holders with equal access.',
  },
  {
    id: '13',
    name: '13 - Senior Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '0',
    classCode: 150,
    description: 'Savings account with senior benefits',
    highlight: 'Discounted services',
    detail: 'Special perks and fee waivers for seniors.',
  },
  {
    id: '14',
    name: '14 - Young Savers',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'AUD',
    fee: '0',
    classCode: 100,
    description: 'Account for children and teens',
    highlight: 'Parental controls',
    detail: 'Parental oversight and educational saving tools.',
  },
  {
    id: '15',
    name: '15 - Wealth Investment',
    type: 'INV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 400,
    description: 'Investment-linked account',
    highlight: 'Market access',
    detail: 'Coming soon: integrated investment services.',
  },
  {
    id: '16',
    name: '16 - Forex Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '12',
    classCode: 250,
    description: 'Multi-currency chequing',
    highlight: 'Low FX fees',
    detail: 'Hold and transact in multiple currencies.',
  },
  {
    id: '17',
    name: '17 - Traveler Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'GBP',
    fee: '1.5',
    classCode: 120,
    description: 'Savings for frequent travelers',
    highlight: 'No foreign ATM fees',
    detail: 'Designed for customers who travel internationally.',
  },
  {
    id: '18',
    name: '18 - Connector Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '6',
    classCode: 110,
    description: 'Digital-first chequing account',
    highlight: 'App-first features',
    detail: 'Full mobile functionality and instant notifications.',
  },
  {
    id: '19',
    name: '19 - Green Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'CAD',
    fee: '0',
    classCode: 130,
    description: 'Eco-friendly savings',
    highlight: 'Supports green initiatives',
    detail: 'Contributes to environmental projects based on balances.',
  },
  {
    id: '20',
    name: '20 - Salary Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '0',
    classCode: 100,
    description: 'Chequing optimized for payroll deposits',
    highlight: 'Fee waiver with payroll',
    detail: 'No monthly fee when direct deposit is set up.',
  },
  {
    id: '21',
    name: '21 - Mini Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '0',
    classCode: 90,
    description: 'Low-balance savings account',
    highlight: 'Great for starting savers',
    detail: 'Low minimums and simplified features for new savers.',
  },
  {
    id: '22',
    name: '22 - Corporate Chequing Plus',
    type: 'BUS',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '50',
    classCode: 350,
    description: 'Full-service corporate chequing',
    highlight: 'Treasury services included',
    detail: 'For larger businesses requiring advanced services.',
  },
  {
    id: '23',
    name: '23 - Estate Savings',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 500,
    description: 'Accounts for estate management',
    highlight: 'Specialized handling',
    detail: 'Coming soon: tools for estate and trust accounts.',
  },
  {
    id: '24',
    name: '24 - Marketplace Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '9',
    classCode: 210,
    description: 'Designed for marketplace sellers',
    highlight: 'Integrated payouts',
    detail: 'Fast payouts and seller-focused reporting tools.',
  },
  {
    id: '25',
    name: '25 - Holiday Saver',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '0',
    classCode: 115,
    description: 'Goal-based savings for holidays',
    highlight: 'Auto-save rules',
    detail: 'Set goals and automate savings for seasonal spending.',
  },
  // 10 additional variants with classCode 500
  {
    id: '26',
    name: '26 - Estate Savings Plus',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '25',
    classCode: 500,
    description: 'Enhanced estate savings with advisory support',
    highlight: 'Dedicated estate advisor',
    detail: 'Includes advisory services for estate planning and transfers.',
  },
  {
    id: '27',
    name: '27 - Trust Reserve',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '30',
    classCode: 500,
    description: 'Reserve account for trust and fiduciary needs',
    highlight: 'Fiduciary-grade handling',
    detail: 'High-security handling for trust assets and disbursements.',
  },
  {
    id: '28',
    name: '28 - Legacy Investment Account',
    type: 'INV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 500,
    description: 'Investment account tailored for legacy planning',
    highlight: 'Estate-focused investments',
    detail:
      'Coming soon: investment products designed for estate preservation.',
  },
  {
    id: '29',
    name: '29 - Private Wealth Savings',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'GBP',
    fee: '40',
    classCode: 500,
    description: 'Savings for high-net-worth customers',
    highlight: 'Personal wealth manager',
    detail: 'Includes personal wealth management and preferential rates.',
  },
  {
    id: '30',
    name: '30 - Trustee Chequing',
    type: 'CHQ',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '20',
    classCode: 500,
    description: 'Chequing for trustees and executors',
    highlight: 'Enhanced reporting and controls',
    detail: 'Custom reporting and permissions for trustee operations.',
  },
  {
    id: '31',
    name: '31 - Estate Growth Saver',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'CAD',
    fee: '15',
    classCode: 500,
    description: 'Growth-focused estate account',
    highlight: 'Balanced growth strategy',
    detail: 'Investment-linked savings for long-term estate growth.',
  },
  {
    id: '32',
    name: '32 - Charitable Trust Account',
    type: 'BUS',
    status: AccountTypeStatus.Active,
    feeCurrency: 'EUR',
    fee: '10',
    classCode: 500,
    description: 'Account for managing charitable trusts',
    highlight: 'Donation tracking tools',
    detail: 'Specialized tools to manage and report charitable distributions.',
  },
  {
    id: '33',
    name: '33 - Generational Wealth Saver',
    type: 'SAV',
    status: AccountTypeStatus.ComingSoon,
    classCode: 500,
    description: 'Account designed for intergenerational transfer',
    highlight: 'Succession planning features',
    detail:
      'Coming soon: features to simplify wealth transfer across generations.',
  },
  {
    id: '34',
    name: '34 - High Value Custody',
    type: 'BUS',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '75',
    classCode: 500,
    description: 'Custody services for high-value assets',
    highlight: 'Secure custody solutions',
    detail: 'Premium custody with insurance and detailed audit trails.',
  },
  {
    id: '35',
    name: '35 - Foundation Reserve Account',
    type: 'SAV',
    status: AccountTypeStatus.Active,
    feeCurrency: 'USD',
    fee: '35',
    classCode: 500,
    description: 'Reserve accounts for foundations and endowments',
    highlight: 'Endowment management tools',
    detail:
      'Optimized for long-term reserves with reporting and payout scheduling.',
  },
];
